import template from './unassociatedFundingLinesModal.html';
import controller from './unassociatedFundingLinesModal.controller';

let UnassociatedFundingLinesModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: 'hmodal-info animated zoomIn'
};

UnassociatedFundingLinesModalComponent.template = template;
UnassociatedFundingLinesModalComponent.controller = controller;

export default UnassociatedFundingLinesModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/unassociatedFundingLinesModal/unassociatedFundingLinesModal.component.js